import React from 'react';

export default function AgentFlowMinimap({ nodes, edges, viewport }) {
  return (
    <div className="absolute bottom-2 right-2 w-32 h-24 bg-[#0A0A0A] border border-[#222] rounded-lg opacity-60">
      <span className="text-[8px] text-[#555] p-1">Minimap</span>
    </div>
  );
}
